<template>
    <div class="current-news">
        <div class="current-news__inner">
            <h3 class="current-news__number">Новость № {{currentNews.id}}</h3>
            <p class="current-news__date">От: {{currentNews.created}}</p>
            <p class="current-news__name">{{currentNews.name}}</p>
            <p class="current-news__content">{{currentNews.content}}</p>

            <router-link to="/news" class="back">Назад</router-link>

            <button
                v-if="userRole == 'ADMIN'" 
                class="full-order__btn full-order__btn_red" 
                @click="deleteNews">Удалить новость</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {
            currentNews: "",
            userRole: ''
        }
    },
    methods: {
        getCurrentNews(){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios.get(`https://lk-berry1.ru:3000/api/news/currentNews`,{ 
                headers: {Authorization: `Bearer ${cookie[1]}`},
                params: {
                    id: this.$route.query.curnews
                }
            }).then((res)=>{
                this.currentNews = res.data
                this.userRole = localStorage.getItem('role')
            })
        },
        deleteNews(){
            let cookie = document.cookie.match(/token=(.+?)(;|$)/);
            axios.delete(`https://lk-berry1.ru:3000/api/news/deleteNews`,{ 
                headers: {Authorization: `Bearer ${cookie[1]}`},
                params: {
                    id: this.$route.query.curnews
                }
            }).then(()=>{
                this.$router.push('/news')
            })
        }
    },
    mounted(){
        this.getCurrentNews()
    }
}
</script>

<style scoped>
    .current-news{
        padding: 0 15px;
    }
    .current-news__inner{
        width: 100%;
        max-width: 600px;
        margin: 25px auto;
        padding: 10px;
        box-shadow: 4px 4px 10px rgb(0 0 0 / 25%);
        border: 1px solid #000;
        border-radius: 5px;
        background-color: #EEE;
    }
    .current-news__number{
        margin-bottom: 10px;
    }
    .current-news__date{
        margin-bottom: 5px;
    }
    .current-news__name{
        margin-bottom: 5px;
        padding-bottom: 5px;
        border-bottom: 1px solid #000;
    }
    .current-news__content{
        margin-bottom: 25px;
        line-height: 150%;
    }
    .back{
        display: inline-block;
        padding: 15px 40px;
        background: #313131 url(../images/arrow-2.png) no-repeat;
        background-position: center 85%;
        border-radius: 4px;
        color: #fff;
        text-decoration: none;
    }
    .full-order__btn{
        margin-bottom: 20px;
        width: 100%;
        border: 1px solid #009ED2;
        background: #009ED2;
        outline: none;
        color: #fff;
        border-radius: 2px;
        padding: 15px 0;
        font-size: 16px;
    }
    .full-order__btn_red{
        margin-top: 25px;
        background-color: #D61921;
        border-color: #b60009;
    }
</style>